import { useQuery } from "@tanstack/react-query"
import { audienceKeys, listAudience, type AudienceStateFilter } from "@/entities/audience"
import { formatRelative } from "@/entities/audience"
import { cn } from "@/shared/lib/utils"
import { Card } from "@/shared/ui/card"

const CARDS: { key: "came" | AudienceStateFilter; label: string; hint: string; tone?: string }[] = [
	{ key: "came", label: "Перешли", hint: "Всего по этой ссылке" },
	{ key: "waiting", label: "Ждут ответа", hint: "Бот ждёт их шага", tone: "text-sky-300" },
	{ key: "idle", label: "Дошли до конца", hint: "Сценарий закончился", tone: "text-emerald-300" },
	{ key: "blocked", label: "Заблокировали бота", hint: "Написать им нельзя", tone: "text-red-300" },
]

/** Четыре числа над воронкой метки: сколько пришло и где эти люди сейчас. */
export function UtmLinkSummary({
	botId,
	code,
	lastAt,
}: {
	botId: string
	code: string
	lastAt?: string | null
}) {
	return (
		<div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
			{CARDS.map((card) => (
				<SummaryCard key={card.key} botId={botId} code={code} card={card} lastAt={lastAt} />
			))}
		</div>
	)
}

function SummaryCard({
	botId,
	code,
	card,
	lastAt,
}: {
	botId: string
	code: string
	card: (typeof CARDS)[number]
	lastAt?: string | null
}) {
	const all = useQuery({
		queryKey: [...audienceKeys.count(botId), { entryLink: code }],
		queryFn: () => listAudience(botId, { entryLink: code }, { skip: 0, take: 1 }),
		select: (data) => data.total,
	})
	const filter = {
		entryLink: code,
		...(card.key === "came" ? {} : { state: card.key }),
	}
	const count = useQuery({
		queryKey: [...audienceKeys.count(botId), filter],
		queryFn: () => listAudience(botId, filter, { skip: 0, take: 1 }),
		select: (data) => data.total,
	})
	return (
		<Card className="px-4 py-3">
			<p className="text-xs text-muted-foreground">{card.label}</p>
			<p className={cn("mt-1 text-2xl font-semibold tabular-nums", card.tone)}>
				{count.isLoading ? "…" : (count.data ?? 0)}
			</p>
			<p className="mt-0.5 text-[11px] text-muted-foreground">
				{card.key === "came"
					? lastAt
						? `Последний переход ${formatRelative(lastAt)}`
						: card.hint
					: all.data
						? `${Math.round(((count.data ?? 0) / all.data) * 100)}% от пришедших`
						: card.hint}
			</p>
		</Card>
	)
}
